import { scheduleServices, shipmentService } from '@/_services'
import i18n from '@/i18n'
import { generalHelpers } from '@/_helpers'
import * as types from './types'

const actions = {
  optimizeSchedule({ commit, dispatch, rootGetters }, { shipmentID }) {
    commit(types.SET_IS_OPTIMIZING, { flag: true })
    commit(types.SET_IS_READY_TO_BE_SAVED, { flag: false })
    var dropsForOptimization = []
    var shipmentDrops = []

    //TODO To be removed when optimization have locations inside
    var locations = {}
    rootGetters['getShipmentSchedule'].stops.forEach((stop) => {
      locations[stop.location.id] = stop.location
    })
    shipmentService.getShipmentWithDropsForOptimization({ shipmentID })
    .then(({ drops, vehicle }) => {
      shipmentDrops = drops
      drops.forEach(({ id, origin, departure, arrival, destination, pickup, delivery }) => {
        // Remove __typename from optimization input
        delete pickup['__typename']
        delete delivery['__typename']
        dropsForOptimization.push({
          id,
          originID: origin.id,
          destinationID: destination.id,
          pickup,
          delivery
        })
      })
      return scheduleServices.optimizeScheduleContext({
        optimize: true,
        drops: dropsForOptimization,
        vehicle: vehicle != null ? {
          depot: vehicle.depot != null ? vehicle.depot.id : null,
          count: vehicle.count != null ? vehicle.count : null,
          id: vehicle.id,
          maxVolume: vehicle.loadArea != null ? generalHelpers.calculateVolume(vehicle.loadArea) : vehicle.vehicleLimits != null ? generalHelpers.calculateVolume(vehicle.vehicleLimits) : null,
          maxWeight: vehicle.loadArea != null ? vehicle.loadArea.maxWeight : vehicle.vehicleLimits != null ? vehicle.vehicleLimits.maxWeight : null,
          type: vehicle.type,
        } : null
      })
    })
    .then((response) => {
      if (response.error != null) {
        dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' }, { root: true })
        console.error(response.error)
      } else {
        //TODO To be removed when optimization have locations inside
        const mappedStops = response.stops.map((stop) => {
          return {...stop, location: locations[stop.location.id]}
        })
        const schedule = { ...response, stops: mappedStops }
        dispatch('shipmentsSetShipmentSchedule', { schedule }, {root: true})
        let optimizedDrops = []
        shipmentDrops.forEach((drop) => {
          let arrival = null
          let departure = null
          const arrivalIndex = schedule.stops.findIndex((stop) => {
            return stop.location.id === drop.destination.id
          })
          if (arrivalIndex >= 0) {
            arrival = schedule.stops[arrivalIndex].arrival
          }
          const departureIndex = schedule.stops.findIndex((stop) => {
            return stop.location.id === drop.origin.id
          })
          if (departureIndex >= 0) {
            departure = schedule.stops[departureIndex].departure
          }
          optimizedDrops.push({
            ...drop,
            arrival,
            departure
          })
        })
        commit(types.SET_OPTIMIZED_DROPS, { drops: optimizedDrops })
        // commit(types.SET_IS_READY_TO_BE_SAVED, { flag: true })
        return scheduleServices.saveOptimizedDrops({ drops: optimizedDrops })
      }
    })
    .then(() => {
      dispatch('showSnackbar', { message: i18n.t('planner.shipment_optimized'), color: 'success' }, { root: true })
    })
    .catch((error) => {
      dispatch('showSnackbar', { message: i18n.t('snackbars.error'), color: 'error' }, { root: true })
      console.error(error)
    })
    .finally(() => {
      commit(types.SET_IS_OPTIMIZING, { flag: false })
    })
  },
  saveScheduleOptimizedDrops({ commit, getters, dispatch }) {
    commit(types.SET_IS_SAVING, { flag: true })
    const drops = getters.getOptimizedDrops
    scheduleServices.saveOptimizedDrops({ drops })
    .then(() => {
      console.log('saved')
    })
    .catch((error) => {
      console.error(error)
    })
    .finally(() => {
      commit(types.SET_IS_SAVING, { flag: false })
      commit(types.SET_OPTIMIZED_DROPS, { drops: null })
      commit(types.SET_IS_READY_TO_BE_SAVED, { flag: false })
    })
    commit(types.SET_IS_SAVING, { flag: false })
  },
  cancelScheduleOptimization({ commit, dispatch }, { shipmentID }) {
    commit(types.SET_OPTIMIZED_DROPS, { drops: null })
    commit(types.SET_IS_READY_TO_BE_SAVED, { flag: false })
    dispatch('setShipmentSchedule', { shipmentID }, {root: true})
  }
}

export default actions
